import { FilterBar } from '@/components/filters/FilterBar';
import { SearchInput } from '@/components/filters/SearchInput';
import { DateRangePicker } from '@/components/filters/DateRangePicker';
import { useAuditLogs } from '@/hooks/useAdminSettings';
import { useState } from 'react';
import { AuditLogTable } from '../components/AuditLogTable';

export function AuditLogPage() {
  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState<string | null>(null);
  const [dateTo, setDateTo] = useState<string | null>(null);
  const { data, isLoading } = useAuditLogs({ search, limit: 50, dateFrom: dateFrom || undefined, dateTo: dateTo || undefined });
  const logs = data?.data || [];

  return (
    <div className="space-y-6">
      <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Journal d'audit</h1><p className="text-sm text-neutral-500">{data?.pagination?.totalItems ?? 0} entrées</p></div>
      <FilterBar>
        <div className="w-72"><SearchInput value={search} onChange={setSearch} placeholder="Rechercher..." /></div>
        <DateRangePicker dateFrom={dateFrom} dateTo={dateTo} onChange={(f, t) => { setDateFrom(f); setDateTo(t); }} />
      </FilterBar>
      <AuditLogTable data={logs} loading={isLoading} />
    </div>
  );
}
